var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{directives:[{name:"mask",rawName:"v-mask",value:('#########'),expression:"'#########'"}],attrs:{"counter":9,"label":(_vm.label + " *"),"name":"inscricaoMatriculaDRE","rules":[
    _vm.campoObrigatorioRule,
    _vm.tamanhoRule(9),
    _vm.digitoVerificadorMatriculaDRERule ].concat( _vm.rules
  ),"value":_vm.value,"dense":"","maxlength":"9","outlined":"","validate-on-blur":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }